/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ApiErrorsService from 'cio/services/api-errors';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import IdentityModel from 'cio/models/identity';
import { task } from 'ember-concurrency';

interface TwilioIdentitiesRowArgs {
  identity: IdentityModel;
  isBeingUsed: boolean;
  disableActions: boolean;
}

export default class TwilioIdentitiesRow extends Component<TwilioIdentitiesRowArgs> {
  @service apiErrors!: ApiErrorsService;

  @tracked isEditing = false;

  saveIdentity = task({ drop: true }, async () => {
    try {
      await this.args.identity?.save();
      this.isEditing = false;
    } catch {}
  });

  @action
  toggleEditing() {
    this.isEditing = !this.isEditing;
  }

  @action
  deleteIdentity() {
    let promise = this.args.identity?.destroyRecord();
    this.apiErrors.attach(promise);
    return promise;
  }

  @action
  discardChanges() {
    this.args.identity.rollbackAttributes();
    this.isEditing = false;
  }
}
